import React, { Component } from "react";

export function DetailPopup({...props}) {
    let api_url = process.env.REACT_APP_API_ENDPOINT;
    
const data = props.data.file;
const tenantKey = props?.data?.tenantKey;

const addressIndex = 0;
  return (
      <>
      <div className="px-4 sm:px-6">
      <div className="mt-6 border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">Aangemaakt door</dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{data?.created_by?.name}</dd>
          </div>
        </dl>
        <dl className="divide-y divide-gray-100">
          <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">Download bestand</dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">

            <a
              href={api_url+'account/files/downloadFile/'+tenantKey+'/'+data.id} target="_blank" 
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Download bestand
            </a>

            
            </dd>
          </div>
        </dl>
        </div>      
      </div>
    </>
      );
}      
